<div [ngStyle]="{
  'padding-top': component.componentSettings.padding_top + 'px',
  'padding-right': component.componentSettings.padding_right + 'px',
  'padding-bottom': component.componentSettings.padding_bottom + 'px',
  'padding-left': component.componentSettings.padding_left + 'px',
  'background-color': component.componentSettings.background_color,
  'border-radius': component.componentSettings.rounded_corners + 'px',
  'height': component.componentSettings.height > 0 ? component.componentSettings.height + 'px' : 'auto'
}">
  <label class="m-0" *ngIf="component.element.label" [ngClass]="{
      'fw-bold': formDesign.label_font_bold,
      'fst-italic': formDesign.label_font_italic,
      'd-none': !component.element.show_label
    }" [ngStyle]="{
      color: formDesign.label_font_color,
      'font-size': formDesign.label_font_size + 'px'
    }">
    <span class="d-inline-block">{{ component.element.label }}</span>
    <span *ngIf="component.element.is_required" class="text-danger d-inline-block ms-1">*</span>
  </label>
  <table style="width: 100%;">
    <tr>
      <td *ngIf="component.element.prefix" style="text-align: center">{{component.element.prefix}}</td>
      <td style="text-align: right">
        <ng-container *ngTemplateOutlet="inputElement"></ng-container>
      </td>
      <td *ngIf="component.element.postfix" style="text-align: center">{{component.element.postfix}}</td>
    </tr>
  </table>
</div>
<ng-template #inputElement>
<!--   
  <div class="form-control" *ngIf="checkNAN(myState); else showVal" [ngStyle]="{
    'background-color': formDesign.field_background_color,
    border:
      'solid ' +
      formDesign.field_border_width +
      'px' +
      formDesign.field_border_color,
    'border-radius': formDesign.field_rounded_corners + 'px'
  }">0</div>
  <ng-template #showVal>
    <dx-number-box [disabled]="true" [value]="myState" [min]="0" format="#,##0.##">
    </dx-number-box>
  </ng-template> -->
  <div class="form-control" [ngStyle]="{
      'background-color': formDesign.field_background_color,
      border:
        'solid ' +
        formDesign.field_border_width +
        'px' +
        formDesign.field_border_color,
      'border-radius': formDesign.field_rounded_corners + 'px'
    }"> {{formatOutput(myState) || component.element.placeholder_text}} </div>
</ng-template>